import { render, staticRenderFns } from "./TheContentbarContainer.vue?vue&type=template&id=552bab6e&scoped=true&"
import script from "./TheContentbarContainer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheContentbarContainer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bab6e",
  null
  
)

export default component.exports